import { CfAsset } from '../asset';

export function mapCfEntityToCfMarketingBlock(cfEntity = {}) {
    const { fields } = cfEntity;
    const { description, title, image } = fields || {};
    return {
        description,
        title,
        image: image && CfAsset.mapCfEntity(image),
    };
}
